export default "__VITE_ASSET__BKHYS$hh__"